import { Link, useSearchParams } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PaymentFailedPage() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id');

  return (
    <div data-testid="payment-failed-page" className="max-w-lg mx-auto px-4 py-24 text-center">
      <div className="w-20 h-20 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-8 animate-fade-up">
        <AlertTriangle className="h-10 w-10 text-destructive" />
      </div>
      <h1 className="font-heading text-4xl font-light text-foreground tracking-tight mb-4 animate-fade-up stagger-1">
        Payment Failed
      </h1>
      <p className="font-body text-base text-foreground/70 mb-3 animate-fade-up stagger-2">
        Paystack was unable to complete your card payment.
      </p>
      <p className="font-body text-sm text-foreground/60 mb-8 animate-fade-up stagger-2">
        Don't worry — your order has been saved as <span className="text-gold font-semibold">unpaid</span>.
        You can retry payment from your profile.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center animate-fade-up stagger-3">
        <Link to={orderId ? `/orders/${orderId}` : '/profile'} data-testid="retry-payment-link">
          <Button variant="ctaPrimary" className="rounded-full px-8 py-6 font-body text-sm font-semibold">
            Retry Payment <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
        <Link to="/profile">
          <Button variant="ctaSecondary" className="rounded-full px-8 py-6 font-body text-sm">
            View My Orders
          </Button>
        </Link>
      </div>
    </div>
  );
}
